import axios from "axios";
import { getHeaders, URL } from "./config";

export const getDnhJobs = async (pageSize, page, callback) => {
    const headers = await getHeaders();
    const url = `${URL}/getDnhJobs?pageSize=${pageSize}&page=${page}`;
    axios
        .get(url, { headers: headers })
        .then((response) => {
            if (response?.data) {
                callback({ status: 200, data: response?.data });
            }
        })
        .catch((error) => {
            callback({ status: 400, message: error?.message });
        });
};

export const getDnhJobDetails = async (jobId, callback) => {
    const headers = await getHeaders();
    const url = `${URL}/getDnhJobDetails?jobId=${jobId}`;
    axios
        .get(url, { headers: headers })
        .then((response) => {
            if (response?.data) {
                callback({ status: 200, data: response?.data });
            }
        })
        .catch((error) => {
            callback({ status: 400, message: error?.message });
        });
};

export const rollbackDnhImport = async (jobId, callback) => {
    const headers = await getHeaders();
    const url = `${URL}/rollbackDnhImport`;
    axios
        .post(url, { jobId }, { headers: headers })
        .then((response) => {
            if (response?.data) {
                callback({ status: 200, data: response?.data });
            }
        })
        .catch((error) => {
            callback({ status: 400, message: error?.message });
        });
};

export const triggerDnhSync = async (callback) => {
    const headers = await getHeaders();
    const url = `${URL}/triggerDnhSync`;
    axios
        .post(url, {}, { headers: headers })
        .then((response) => {
            if (response?.data) {
                callback({ status: 200, data: response?.data });
            }
        })
        .catch((error) => {
            callback({ status: 400, message: error?.message });
        });
};
